module.exports = __webpack_public_path__ + "img/new-listing.27170c42.png";